var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.72245 6.51351C0.569827 7.04085 0.810899 8.65302 2.12926 8.66055L7.73417 8.68315C7.84717 8.68315 7.88484 8.72835 7.88484 8.84135L7.89991 14.4086C7.89991 15.7044 9.5196 15.9982 10.0921 14.7476L15.795 2.40776C16.4052 1.0894 15.3807 0.215515 14.1226 0.795593L1.72245 6.51351ZM3.51542 7.30452C3.45515 7.30452 3.43255 7.23672 3.50035 7.19905L14.1226 2.33996C14.213 2.30229 14.2657 2.35502 14.2205 2.44543L9.35387 13.0375C9.32373 13.1128 9.2484 13.0978 9.2484 13.03L9.27853 7.95993C9.27853 7.50039 9.06006 7.27439 8.58545 7.27439L3.51542 7.30452Z",
    fill: "#2F84EE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.6272174805bf22dd512126f7bdd71a10.svg";
export { ForwardRef as ReactComponent };